module.exports = __webpack_public_path__ + "images/psp/ATV/motorcycle.png";